import { Pagination, InAppNotification, InAppNotificationType, MaintenanceInfo } from '@interfaces';

export type InAppNotificationsState = Readonly<{
  loading: boolean;
  errorMessage: string | null;
  shortlist: InAppNotification[];
  shortlistPagination: Pagination;
  unreadCount: number | null;
  unreadCountOfType: {
    notificationType: InAppNotificationType;
    unreadCount: number;
    relatedForeignerId: string | null;
    relatedCandidateVerificationId: string | null;
  };
  loadingMore: boolean;
  maintenance: MaintenanceInfo;
  loadingMaintenance: boolean;
}>;

export const defaultPagination = {
  all: 0,
  limit: 25,
  offset: 0,
  orderBy: 'createdAt',
  orderDir: 'desc',
};

export const initialState: InAppNotificationsState = {
  loading: false,
  errorMessage: null,
  shortlist: [],
  shortlistPagination: { ...(defaultPagination as Pagination) },
  unreadCount: null,
  unreadCountOfType: {
    notificationType: null,
    unreadCount: null,
    relatedForeignerId: null,
    relatedCandidateVerificationId: null,
  },
  loadingMore: false,
  maintenance: {
    maintenanceUpcoming: null,
    message: null,
  },
  loadingMaintenance: false,
};
